<template>
  <div class="basic">
    <div class="flex-container item-container">
      <template v-if="!isInit">
        <loading :message="'読み込み中...'"></loading>
      </template>

      <p v-else-if="isInit && isError">社員情報の取得に失敗しました</p>

      <template v-else-if="isInit && !isError">
        <div class="col-item">
          <b class="title">所属</b>
          <p>{{ syainDetail.syozoku_name ?? '所属なし' }}</p>
        </div>
        <div class="col-item">
          <b class="title">勤務状況</b>
          <p>{{ syainDetail.kinmuStatus }}</p>
        </div>
        <div class="col-item">
          <b class="title">退職日</b>
          <p>{{ dateFormat(syainDetail.taisyoku_date) }}</p>
        </div>
        <div class="col-item">
          <b class="title">最終利用可能日</b>
          <p>{{ dateFormat(syainDetail.last_available_day) }}</p>
        </div>
        <div class="col-item">
          <b class="title">役職</b>
          <p>{{ syainDetail.yakusyoku_name }}</p>
        </div>
        <div class="col-item">
          <b class="title">権限ロール</b>
          <p>{{ syainDetail.role_name }}</p>
        </div>
        <div class="col-item">
          <b class="title">入社日</b>
          <p>{{ dateFormat(syainDetail.nyuusya_date) }}</p>
        </div>
        <div class="col-item">
          <b class="title">有休付与基準日</b>
          <p>{{ dateFormat(syainDetail.yuukyuu_reference_date) }}</p>
        </div>
        <div class="col-item">
          <b class="title">社員番号</b>
          <p>{{ syainDetail.staff_code }}</p>
        </div>
        <div class="col-item">
          <b class="title">氏名</b>
          <p>{{ syainDetail.staff_name }}</p>
        </div>
        <div class="col-item">
          <b class="title">フリガナ</b>
          <p>{{ syainDetail.staff_kana }}</p>
        </div>
        <div class="col-item">
          <b class="title">性別</b>
          <p>{{ syainDetail.gender }}</p>
        </div>
        <div class="col-item">
          <b class="title">生年月日</b>
          <p>{{ dateFormat(syainDetail.birthday_date) }}</p>
        </div>
        <div class="col-item">
          <b class="title">郵便番号</b>
          <p>{{ syainDetail.zipCode }}</p>
        </div>
        <div class="col-item">
          <b class="title">住所</b>
          <p>{{ syainDetail.address }}</p>
        </div>
        <div class="col-item">
          <b class="title">メールアドレス</b>
          <p>{{ syainDetail.email }}</p>
        </div>
        <div class="col-item">
          <b class="title">連絡先電話番号（固定）</b>
          <p>{{ syainDetail.tel }}</p>
        </div>
        <div class="col-item">
          <b class="title">連絡先電話番号（携帯）</b>
          <p>{{ syainDetail.keitai_tel }}</p>
        </div>
        <div class="col-item">
          <b class="title">緊急連絡先名</b>
          <p>{{ syainDetail.emergency_name }}</p>
        </div>
        <div class="col-item">
          <b class="title">緊急連絡先 電話番号</b>
          <p>{{ syainDetail.emergency_tel }}</p>
        </div>
        <div class="col-item">
          <b class="title">免許証の有無</b>
          <p>{{ syainDetail.driversLicense }}</p>
        </div>
        <div class="col-item" v-if="syainDetail.is_drivers_license">
          <b class="title">免許証の種類</b>
          <p>{{ syainDetail.drivers_license }}</p>
        </div>
        <div class="col-item">
          <b class="title">保険証番号</b>
          <p>{{ syainDetail.hokensyou_no }}</p>
        </div>
        <div class="col-item">
          <b class="title">雇用保険</b>
          <p>{{ syainDetail.koyou_hoken }}</p>
        </div>
        <div class="col-item">
          <b class="title">Web明細</b>
          <p>{{ syainDetail.webMeisai }}</p>
        </div>
        <div class="col-item" v-show="!syainDetail.is_web_meisai">
          <b class="title">未対応理由</b>
          <p>{{ syainDetail.web_mitaiou_notes }}</p>
        </div>
        <div class="col-item">
          <b class="title">資格</b>
          <p class="pre">{{ syainDetail.shikaku_notes }}</p>
        </div>
        <div class="col-item">
          <b class="title">異動歴</b>
          <p class="pre">{{ syainDetail.idoureki_notes }}</p>
        </div>
        <div class="col-item">
          <b class="title">備考</b>
          <p class="pre">{{ syainDetail.notes }}</p>
        </div>
        <div class="col-item table">
          <b class="title">その他休日</b>
          <table>
            <tr v-for="(item, index) in syainDetail.sonota_kyuujitus" :key="index">
              <td> {{ SyainConst.SONOTA_KYUUJITSU_TYPE.find(v => v.val == item.sonota_kyuujitsu_type)?.label }}：</td>
              <td> {{ dateFormat(item.start_date) }} </td>
              <td>～</td>
              <td> {{ dateFormat(item.end_date) }} </td>
            </tr>
          </table>
        </div>

        <div class="buttons">
          <button type="button" class="btn primary" @click="openBukaSelectModal()">PX登録用のCSVダウンロード</button>
          <button type="button" class="btn primary">
            <router-link :to="{ name: RouterConst.SYAIN_EDIT, params: { id: syainDetail.user_id } }">
              <i class="fa-solid fa-pen"></i>編集する
            </router-link>
          </button>
        </div>
      </template>
    </div>
  </div>
  <modal ref="bukaSelectModalRef" :title="bukaSelectModalParts.title">
    <buka-selecter v-on:select="selectBuka" :userId="syainDetail.user_id" v-on:cancel="closeBukaSelectModal()">
    </buka-selecter>
  </modal>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useCreate } from "@/composable/px/create";
import { useBukaSelectModal } from "@/composable/modal/buka-selecter";
import BukaSelecter from "@/components/koyoukeiyaku/BukaSelecter.vue";
import { dateFormat } from "@/filters/common";
import { KeiyakuDetailWithSyuugyouBasyoAndBuka } from "@/types/KoyouKeiyaku";
import { RouterConst } from "@/const/Router";
import { useSyainDetail } from "@/composable/syain/detail/init";
import SyainConst from "@/const/SyainMaster/Option";

export default defineComponent({
  props: {
    userId: {
      type: Object as () => number | null,
      default: null
    }
  },
  setup(props) {
    // 初期処理
    const { downloadSyainCSV } = useCreate()
    const { bukaSelectModalParts, bukaSelectModalRef, openBukaSelectModal, closeBukaSelectModal } = useBukaSelectModal()
    const { userId, syainDetail, getSyainDetail, setUserId } = useSyainDetail()

    const selectBuka = async (koyouKeiyaku: KeiyakuDetailWithSyuugyouBasyoAndBuka | null) => {
      closeBukaSelectModal()
      let keiyakuId = null;
      if(koyouKeiyaku){
        keiyakuId = koyouKeiyaku.koyou_keiyaku_id
      }
      if(syainDetail.value.user_id){
        await downloadSyainCSV(syainDetail.value.user_id, keiyakuId)
      }
    }
    const isInit = ref(false)
    const isError = ref(false)

    onMounted(async () => {
      if (props.userId) {
        await setUserId(props.userId)
      }

      if (userId) {
        await getSyainDetail(userId.value)
      } else {
        isError.value = true
      }

      isInit.value = true
    })

    return {
      dateFormat,
      downloadSyainCSV,
      bukaSelectModalParts,
      bukaSelectModalRef,
      openBukaSelectModal,
      selectBuka,
      closeBukaSelectModal,
      RouterConst,
      syainDetail,
      isError,
      isInit,
      SyainConst,
    };
  },
  components: {
    'buka-selecter': BukaSelecter
  }
});
</script>

<style lang="scss" scoped>
@import '@scss/components/syain-detail.scss';
</style>
